import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { RewardSummary } from './RewardSummary';

export class RewardSummaryResource extends FBaseService {
  public async getRewardSummary(fiId: string, cycleId: number, productId: number | null): Promise<RewardSummary[]> {
    let url: string = `/api/rcx/reporting/${fiId}/reward-summary/${cycleId}`;
    if (productId) {
      url += `?productId=${productId}`;
    }

    const response: AxiosResponse = await this.apiClient.get(url);

    const results: RewardSummary[] = response.data.data;
    return results;
  }
}

export default RewardSummaryResource;
